import { useCallback, useEffect, useRef, useState } from "react";
import { SidebarProps } from "../index.types";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { hasAcademyPlan } from "app/utils/subscription";

const useSidebarDropdownModel = ({ user }: SidebarProps) => {
  const { t } = useTranslation();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const history = useHistory();

  const [showModal, setPaywallModal] = useState(false);

  const onPaywallOpen = useCallback(() => {
    setPaywallModal(true);
  }, []);

  const onPaywallClose = useCallback(() => {
    setPaywallModal(false);
  }, []);

  const listData = [
    {
      title: t("Account Settings"),
      isBold: false,
      display: true,
      onClickFunc: () => history.push("/account/edit"),
    },
    {
      title: t("Tags"),
      isBold: false,
      display: true,
      onClickFunc: () => history.push("/account/tags"),
    },
    {
      title: t("Benefits"),
      isBold: true,
      display: user?.hasCoachPlusSubscription && !user.hasTrialSubscription,
      onClickFunc: () => history.push("/benefits"),
    },
    {
      title: t("Upgrade to CoachNow PRO"),
      isBold: true,
      // Academy subscribers/trialists shouldn't be nudged to PRO. Gate on the
      // plan code (coachacademy+...) rather than the display name, which isn't
      // reliably "academy" during the trial.
      display:
        !user?.hasCoachPlusSubscription &&
        user?.kind === "coach" &&
        !hasAcademyPlan(user),
      onClickFunc: () => onPaywallOpen(),
    },
  ];

  const modalHandler = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      setIsOpen(false); // click inside
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen, dropdownRef]);

  return {
    modalHandler,
    dropdownRef,
    isOpen,
    listData,
    showModal,
    onPaywallClose,
    onPaywallOpen,
  };
};

export default useSidebarDropdownModel;
